import { combineReducers } from "redux";
import auth from "./auth/reducer";
import solicitations from "./solicitation/reducer";
import organization from "./organization/reducer";
import vehicles from "./vehicles/reducer";

const allReducers = combineReducers({
  auth,
  solicitations,
  vehicles,
  organization,
});

const rootReducer = (state, action) => {
  if (action.type === 'RESET_STATE') {
    localStorage.clear()
    state = undefined;
  }

  return allReducers(state, action);
};

export default rootReducer;